/* Lista produktow kategorii: widok, szuflada filtrow, filtry kolekcji (podglad liczby i podmiana wynikow), sortowanie, opis. */
(() => {
  if (window.cvListInit) return;
  window.cvListInit = true;

  const mobileQuery = window.matchMedia('(max-width: 989px)');

  // Adres listy z biezacymi filtrami. Parametr "view" (szablon alternatywny w podgladzie) zostaje,
  // inaczej Shopify wyrenderowalby domyslny szablon kolekcji bez tej sekcji.
  const buildUrl = (root, params) => {
    const url = new URL(root.dataset.collectionUrl, window.location.origin);
    const view = new URLSearchParams(window.location.search).get('view');
    if (view) url.searchParams.set('view', view);
    params.forEach(([key, value]) => {
      if (String(value).trim() !== '') url.searchParams.append(key, value);
    });
    return url;
  };

  const formParams = (root) => {
    const form = root.querySelector('[data-cv-form]');
    const params = form ? [...new FormData(form).entries()] : [];
    const sort = root.querySelector('[data-cv-sort]');
    if (sort) params.push(['sort_by', sort.value]);
    return params;
  };

  const sectionUrl = (root, url) => {
    const fetchUrl = new URL(url, window.location.origin);
    fetchUrl.searchParams.set('section_id', root.dataset.sectionId);
    return fetchUrl;
  };

  const fetchSection = async (root, url) => {
    const response = await fetch(sectionUrl(root, url));
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const html = await response.text();
    return new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cv-list]');
  };

  // Podmiana calej sekcji na wersje dla nowego adresu (filtry, sortowanie, strona), bez przeladowania strony
  const navigate = async (root, url, { push = true } = {}) => {
    root.classList.add('is-loading');
    try {
      const fresh = await fetchSection(root, url);
      if (!fresh) throw new Error('brak sekcji w odpowiedzi');
      const wasOpen = root.querySelector('[data-cv-filters]')?.classList.contains('is-open');
      // Grupy filtrow rozwiniete przez klienta zostaja rozwiniete po podmianie (domyslnie otwarta jest tylko pierwsza)
      const openKeys = new Set([...root.querySelectorAll('details[data-cv-filter-key]')].filter((d) => d.open).map((d) => d.dataset.cvFilterKey));
      fresh.querySelectorAll('details[data-cv-filter-key]').forEach((d) => {
        d.open = openKeys.has(d.dataset.cvFilterKey);
      });
      document.body.style.overflow = '';
      root.replaceWith(fresh);
      if (push) history.pushState({ cvList: true }, '', url);
      initList(fresh);
      if (wasOpen && !mobileQuery.matches) fresh.querySelector('[data-cv-filters]')?.classList.remove('is-open');
      const results = fresh.querySelector('[data-cv-results]');
      if (results && results.getBoundingClientRect().top < 0) results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } catch (error) {
      // Gdy podmiana sie nie uda, zwykle przejscie pod ten sam adres i tak pokaze wynik
      window.location.href = url;
    }
  };

  const initPrice = (root, onChange) => {
    root.querySelectorAll('[data-cv-price]').forEach((price) => {
      const max = Number(price.dataset.max) || 1;
      const fromInput = price.querySelector('[data-cv-price-from]');
      const toInput = price.querySelector('[data-cv-price-to]');
      const fromRange = price.querySelector('[data-cv-range-from]');
      const toRange = price.querySelector('[data-cv-range-to]');
      const slider = price.querySelector('.cv-list-price__slider');

      const paint = () => {
        slider.style.setProperty('--cv-from', `${(Number(fromRange.value) / max) * 100}%`);
        slider.style.setProperty('--cv-to', `${(Number(toRange.value) / max) * 100}%`);
      };

      const fromRanges = () => {
        if (Number(fromRange.value) > Number(toRange.value)) fromRange.value = toRange.value;
        fromInput.value = Number(fromRange.value) > 0 ? fromRange.value : '';
        toInput.value = Number(toRange.value) < max ? toRange.value : '';
        paint();
      };

      const fromInputs = () => {
        const from = Math.min(Math.max(parseInt(fromInput.value, 10) || 0, 0), max);
        const to = Math.min(Math.max(parseInt(toInput.value, 10) || max, from), max);
        fromRange.value = from;
        toRange.value = to;
        paint();
      };

      [fromRange, toRange].forEach((range) => {
        range.addEventListener('input', fromRanges);
        range.addEventListener('change', onChange);
      });
      [fromInput, toInput].forEach((input) => {
        input.addEventListener('input', () => {
          input.value = input.value.replace(/[^\d]/g, '');
        });
        input.addEventListener('change', () => {
          fromInputs();
          onChange();
        });
      });
    });
  };

  const initList = (root) => {
    if (root.dataset.cvReady) return;
    root.dataset.cvReady = '1';

    const grid = root.querySelector('[data-cv-grid]');
    const filters = root.querySelector('[data-cv-filters]');
    const form = root.querySelector('[data-cv-form]');
    const applyButton = root.querySelector('[data-cv-apply]');
    const openButton = root.querySelector('[data-cv-filters-open]');

    root.querySelectorAll('[data-cv-view]').forEach((button) => {
      button.addEventListener('click', () => {
        root.querySelectorAll('[data-cv-view]').forEach((other) => other.setAttribute('aria-pressed', String(other === button)));
        if (grid) grid.dataset.view = button.dataset.cvView;
      });
    });

    root.querySelectorAll('[data-cv-sort]').forEach((select) => {
      select.addEventListener('change', () => {
        root.querySelectorAll('[data-cv-sort]').forEach((other) => (other.value = select.value));
        navigate(root, buildUrl(root, formParams(root)).toString());
      });
    });

    root.querySelectorAll('.cv-list-card__wishlist').forEach((button) => {
      button.addEventListener('click', () => {
        button.setAttribute('aria-pressed', String(button.getAttribute('aria-pressed') !== 'true'));
      });
    });

    // Chipy wybranych filtrow, "Wyczysc" i stronicowanie: te same adresy co bez skryptu, tylko bez przeladowania
    root.querySelectorAll('a[data-cv-nav][href]').forEach((link) => {
      link.addEventListener('click', (event) => {
        if (event.metaKey || event.ctrlKey || event.shiftKey) return;
        event.preventDefault();
        const url = new URL(link.href, window.location.origin);
        const view = new URLSearchParams(window.location.search).get('view');
        if (view) url.searchParams.set('view', view);
        navigate(root, url.toString());
      });
    });

    // Wyszukiwarka wartosci w dlugich listach (np. marki)
    root.querySelectorAll('[data-cv-option-search]').forEach((input) => {
      const items = input.closest('.cv-list-filter__body').querySelectorAll('[data-cv-option-label]');
      input.addEventListener('input', () => {
        const query = input.value.trim().toLowerCase();
        items.forEach((item) => (item.hidden = query !== '' && !item.dataset.cvOptionLabel.includes(query)));
      });
    });

    if (form && applyButton) {
      // Zaznaczenie filtra przelicza w tle liczbe produktow na przycisku i liczby przy opcjach;
      // wyniki zmieniaja sie dopiero po kliknieciu przycisku (Figma: "Pokaz 268 produktow")
      let previewToken = 0;
      const preview = async () => {
        const token = ++previewToken;
        applyButton.classList.add('is-loading');
        try {
          const fresh = await fetchSection(root, buildUrl(root, formParams(root)).toString());
          if (token !== previewToken || !fresh) return;
          const freshApply = fresh.querySelector('[data-cv-apply]');
          if (freshApply) applyButton.textContent = freshApply.textContent;
          form.querySelectorAll('[data-cv-filter-input]').forEach((input) => {
            const twin = [...fresh.querySelectorAll('[data-cv-filter-input]')].find(
              (other) => other.name === input.name && other.value === input.value
            );
            const count = input.closest('label')?.querySelector('[data-cv-count]');
            if (count) count.textContent = twin ? twin.closest('label').querySelector('[data-cv-count]')?.textContent || '' : '(0)';
            input.closest('li').classList.toggle('is-empty', !twin && !input.checked);
          });
        } catch (error) {
          applyButton.textContent = applyButton.dataset.cvFallback || applyButton.textContent;
        } finally {
          if (token === previewToken) applyButton.classList.remove('is-loading');
        }
      };

      let timer;
      const schedule = () => {
        clearTimeout(timer);
        timer = setTimeout(preview, 250);
      };

      form.querySelectorAll('[data-cv-filter-input]').forEach((input) => input.addEventListener('change', schedule));
      initPrice(root, schedule);

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        navigate(root, buildUrl(root, formParams(root)).toString());
      });
    }

    if (!filters || !openButton) return;

    const close = () => {
      if (!filters.classList.contains('is-open')) return;
      filters.classList.remove('is-open');
      openButton.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      openButton.focus();
    };

    openButton.addEventListener('click', () => {
      filters.classList.add('is-open');
      openButton.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      filters.querySelector('.cv-list-filters__close')?.focus();
    });

    root.querySelectorAll('[data-cv-filters-close]').forEach((element) => {
      element.addEventListener('click', () => {
        if (mobileQuery.matches) close();
      });
    });

    const onKey = (event) => {
      if (!root.isConnected) return document.removeEventListener('keydown', onKey);
      if (event.key === 'Escape') close();
    };
    document.addEventListener('keydown', onKey);

    const onMedia = (event) => {
      if (!root.isConnected) return mobileQuery.removeEventListener('change', onMedia);
      if (!event.matches) close();
    };
    mobileQuery.addEventListener('change', onMedia);
  };

  const initSeo = (root) => {
    if (root.dataset.cvReady) return;
    root.dataset.cvReady = '1';
    const content = root.querySelector('[data-cv-seo-content]');
    const toggle = root.querySelector('[data-cv-seo-toggle]');
    if (!content || !toggle) return;
    const label = toggle.querySelector('[data-cv-seo-label]');
    const moreText = label.textContent;

    content.classList.add('is-collapsed');
    // Przycisk tylko wtedy, gdy tresc jest dluzsza niz zwinieta wysokosc z projektu
    const update = () => {
      if (toggle.getAttribute('aria-expanded') === 'true') return;
      toggle.hidden = content.scrollHeight <= content.clientHeight + 1;
      content.classList.toggle('is-collapsed', !toggle.hidden);
    };

    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      content.classList.toggle('is-collapsed', expanded);
      label.textContent = expanded ? moreText : label.dataset.less || moreText;
    });

    update();
    window.addEventListener('resize', () => {
      if (toggle.getAttribute('aria-expanded') === 'true') return;
      content.classList.add('is-collapsed');
      update();
    });
  };

  const init = () => {
    document.querySelectorAll('[data-cv-list]').forEach(initList);
    document.querySelectorAll('[data-cv-seo]').forEach(initSeo);
  };

  // Wstecz/dalej w przegladarce po zmianie filtrow: sekcja dla adresu z historii
  window.addEventListener('popstate', () => {
    const root = document.querySelector('[data-cv-list]');
    if (root) navigate(root, window.location.href, { push: false });
  });

  // Edytor motywu podmienia sekcje bez przeladowania strony
  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
